import React, { Component, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import UIIcon from './UIIcon';
import { RefinedUIContext } from './RefinedUIContext';

import PageLoading from './PageLoading';
import {SCAN_SCANNING, SCAN_OK, SCAN_ERROR} from '../../utils/scannerStatus';

const QRScanner = lazy(() => import('./QRScanner'));
const BarcodeQRScannerComponent = lazy(() => import('./BarcodeScanner'));

export default class SearchInventoryBar extends Component {
  static contextType = RefinedUIContext;

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      showModal: false,
      scanStatus: SCAN_SCANNING,
      scanResult: undefined,
      scannedInv: undefined,
      readBarInv: '',
      times: 1,
      format: null,
    };

    this.debounceRedirection = _.debounce(this.redirectToInventory, 1000);
    this.debounceInputChange = _.debounce(this.onReadBarcode, 300);
  }
  // ---------------------------------------------------------------------------
  // QR scanning
  // ---------------------------------------------------------------------------
  closeScanner = () => {
    this.setState({ showModal: false });
  };

  openScanner = () => {
    this.setState({ showModal: true });
  };

  onScanItem = (id, format, times) => {
    this.setState({
      scanStatus: SCAN_OK,
      scanResult: `Scanned Inventory #${id}`,
      scannedInv: id,
      showModal: false,
      times,
      format
    }, () => {
      this.debounceRedirection(id, true);
    });
  };

  onScanError = () => {
    this.setState({ scanStatus: SCAN_ERROR, scanResult: `Error scanning inventory`}, () => {
      this.debounceRedirection();
    });
  };

  // ---------------------------------------------------------------------------
  // Barcode reader (input)
  // ---------------------------------------------------------------------------
  onReadBarcode = (event) => {
    let readBarInv = event.target.value;
    this.setState({ readBarInv });
  };

  redirectToInventory = (id, from_scanner=false) => {
    if (id){
      this.props.goToInventory(id, this.state.format, this.state.times, from_scanner);
    }
    this.setState({ scanStatus: SCAN_SCANNING, scanResult: undefined,
      showModal: false, scannedInv: undefined, readBarInv: '', times: 1, format: null});
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    const { forOrderReceived, forPendingInventory, autoFocus } = this.props;
    const refinedUI = this.props.refinedUI ?? this.context;
    const ScanControl = refinedUI ? 'button' : 'span';
    return (
      <div className="search-bar">
        {/* Header */}
        <div className="search-bar--header">
          {refinedUI && !forOrderReceived ? <UIIcon name="search" size={16} /> : <i className={`fa ${forOrderReceived ? 'fa-check' : 'fa-search'}`}></i>}
          <span>{forOrderReceived ? 'Received Item' : 'Search Inventory'}</span>
        </div>
        {/* Body */}
        <div className="search-bar--body justify-content-start">
          <form
            className={`${forOrderReceived ? 'col-sm-3 pl-05' : 'd-flex'} ${forPendingInventory ? 'w-100' : ''}`}
            onSubmit={(e) => {e.preventDefault(); this.redirectToInventory(this.state.readBarInv);}}
          >
            <input type="text"
                   placeholder="Barcode"
                   aria-label={refinedUI ? 'Barcode' : undefined}
                   className={`form-control ${forOrderReceived ? 'mr-1' : 'search-bar--barcode'}`}
                   value={this.state.readBarInv}
                   onChange={this.onReadBarcode}
                   autoFocus={autoFocus}>
            </input>
          </form>
          {this.props.multiple_times_allowed &&
            <div className={`flex-align-center pr-05 ${this.state.times < 0 && "has-danger"}`}>
              <span className="pr-05">Repeat</span>
              <input type="number" aria-label="Number of scans"
                className={`form-control ${!forOrderReceived && 'search-bar--barcode'}`}
                value={this.state.times}
                min={1}
                onChange={(e) => this.setState({times: e.target.value})}/>
              <span className="pl-05 pr-05">times</span>
            </div>
          }
          <ScanControl type={refinedUI ? 'button' : undefined} className={`search-bar--qr btn btn-primary mr-05 ${forPendingInventory ? 'w-100 m-0' : ''}`} onClick={this.openScanner}>
            {refinedUI ? <UIIcon name="scan" size={18} /> : <i className="fa fa-qrcode mr-05" aria-hidden="true"></i>}
            <span>Scan</span>
          </ScanControl>
          {this.state.showModal && <Suspense fallback={<PageLoading label="Loading scanner…" />}>
            {this.props.barcode_scanner ?
            <BarcodeQRScannerComponent
                show={this.state.showModal}
                onHide={this.closeScanner}
                onScan={(code, format, times) => this.onScanItem(code, format, times)}
                onError={this.onScanError}
                multiple_times_allowed={this.props.multiple_times_allowed}
            />
            :
            <QRScanner show={this.state.showModal}
              onHide={this.closeScanner}
              onScan={this.onScanItem}
              onError={this.onScanError}
              scannedItems={[]}
              scanResult={this.state.scanResult}
              scanStatus={this.state.scanStatus}/>
            }
          </Suspense>}
        </div>
      </div>
    );
  }
};

SearchInventoryBar.propTypes = {
  forOrderReceived: PropTypes.bool,
  forPendingInventory: PropTypes.bool,
  autoFocus: PropTypes.bool,
};

SearchInventoryBar.defaultProps = {
  forOrderReceived: false,
  forPendingInventory: false,
  autoFocus: false,
};
